export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const syncTypeElement = doc.querySelector(
      '#administration_sync_entity_sync_type'
    ) as HTMLSelectElement
    const extraAttributesInputs = doc.querySelectorAll(
      '.js-sync-entity-extra-attributes input'
    )
    const extraAttributesContainers = doc.querySelectorAll(
      "[data-behaviour~='hide-unneeded-fields-for-sync-type']"
    )

    function updateSyncInputs(): void {
      extraAttributesInputs.forEach((input) => {
        ;(input as HTMLInputElement).disabled = true
      })
      extraAttributesInputs.forEach((input) => {
        ;(input as HTMLInputElement).disabled = false
      })
      extraAttributesContainers.forEach(
        (element) => ((element as HTMLInputElement).style.display = 'none')
      )

      const syncType = syncTypeElement.value
      const syncTypeElements = doc.querySelectorAll(
        `[data-sync-type='${syncType}']`
      )
      syncTypeElements.forEach(
        (element) => ((element as HTMLInputElement).style.display = 'block')
      )
      syncTypeElements.forEach((element) => {
        const input = element.querySelector('input') as HTMLInputElement

        if (input) {
          input.disabled = false
        }
      })
    }

    function handleChange(event: Event): void {
      if (event.target === syncTypeElement && syncTypeElement) {
        updateSyncInputs()
      }
    }

    if (syncTypeElement) {
      updateSyncInputs()
      syncTypeElement.removeEventListener('change', handleChange)
      syncTypeElement.addEventListener('change', handleChange)
    }
  })
}
